import React, { useState,useEffect,  useRef } from "react";
import { Modal, Box, Button, CircularProgress,IconButton ,Typography } from "@mui/material";
import Webcam from "react-webcam";
import { toast } from "react-hot-toast";
import { BASE_URL } from "../../../../components/BaseUrl";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CustomButton from "../../../../components/CustomButton";
import { decryptToken } from "../../../../Utlis/Encryption";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const videoConstraints = {
  width: 400,
  height: 250,
  facingMode: "user", // front camera
};

const FaceScanModal = ({ open, onClose, onContinue }) => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [faceFileId, setFaceFileId] = useState(null); // uploaded image URL
  const [uploading, setUploading] = useState(false);
const { t, i18n } = useTranslation();
const [validationError, setValidationError] = useState("");
const [validationFailed, setValidationFailed] = useState(false);
const [verifyingFace, setVerifyingFace] = useState(false);
const [cameraReady, setCameraReady] = useState(false);
const [cameraError, setCameraError] = useState("");

useEffect(() => {
  console.log("🟢 FaceScanModal Mounted");
  return () => {
    console.log("🔴 FaceScanModal Unmounted");
  };
}, []);

useEffect(() => {
  if (open) {
    setCapturedImage(null);
    setFaceFileId(null);
    setUploading(false);
    setVerifyingFace(false);
    setValidationError("");
    setValidationFailed(false);
    setCameraReady(false);
    setCameraError("");
  }
}, [open]);
    const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const validateFace = async (imageUrl) => {
  const endpoint = `${BASE_URL}/attendance/validate-face`;
  const requestBody = { selfie: imageUrl };

  try {
    console.group("🧪 [FACE VALIDATION] Request");
    console.log("Endpoint:", endpoint);
    console.log("Selfie URL:", imageUrl);
    console.log("Has auth token:", !!decryptedToken);
    console.log("Request body:", requestBody);
    console.groupEnd();

    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify(requestBody),
    });

    const rawText = await res.text();
    let data = null;
    try {
      data = rawText ? JSON.parse(rawText) : null;
    } catch (parseError) {
      console.error("❌ [FACE VALIDATION] Failed to parse JSON response:", parseError);
    }

    console.group("📥 [FACE VALIDATION] Response");
    console.log("HTTP status:", res.status, res.statusText);
    console.log("Response OK:", res.ok);
    console.log("Raw response:", rawText);
    console.log("Parsed response:", data);
    console.groupEnd();

    const currentLang = i18n.language;

    const isFaceValid =
      data?.data?.valid === true ||
      data?.valid === true ||
      data?.success === true ||
      data?.status === true;
    const hasApiError = data?.error === true;

    // ✅ Valid
    if (res.ok && !hasApiError && isFaceValid) {
      setValidationError("");
      setValidationFailed(false);
      toast.success(
        currentLang === "es"
          ? "Su rostro ha sido validado correctamente."
          : "Your face has been validated successfully."
      );
      return true;
    }

    // ❌ Invalid → show YOUR custom message
    setValidationError(
      currentLang === "es"
        ? "Su rostro no coincide con el escaneo facial registrado; por lo tanto, este registro será considerado inválido."
        : "Your face does not match the registered face scan; therefore, this task will be considered invalid."
    );

    return false;

  } catch (err) {
    console.error("🔥 [FACE VALIDATION] Network/JS error:", err);
    const currentLang = i18n.language;

    setValidationError(
      currentLang === "es"
        ? "Su rostro no coincide con el escaneo facial registrado; por lo tanto, este registro será considerado inválido."
        : "Your face does not match the registered face scan; therefore, this task will be considered invalid."
    );

    return false;
  }
};

  // ✅ Capture + upload face image
  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
    setUploading(true);

    try {
      // Convert base64 → Blob
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const formData = new FormData();
      formData.append("image", blob, "face.jpg"); // ✅ must be "image"

      console.log("📤 Uploading to:", `${BASE_URL}/upload/image`);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData, // ❌ no headers
      });

      const rawText = await res.text();
      console.log("📥 Raw server response:", rawText);

      let data;
      try {
        data = JSON.parse(rawText);
      } catch (err) {
toast.error(t("faceScan.invalidJson"));        console.error("❌ JSON parse failed:", err);
        setUploading(false);
        return;
      }

      if (!res.ok || data.error) {
toast.error(t("faceScan.uploadFailed"));
        console.error("❌ Upload failed:", data.message || "Server error");
        setUploading(false);
        return;
      }

      if (data.data?.url) {
        console.log("✅ Face image uploaded successfully:", data.data.url);
        setFaceFileId(data.data.url);
toast.success(t("faceScan.uploadSuccess"));
      } else {
toast.error(t("faceScan.noUrl"));
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
toast.error(t("faceScan.uploadErrorDetails"));
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
   <Box
    sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      p: 2,
    }}
  >
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
        borderRadius: 2,
        width: "100%",
        maxWidth: 600,
        maxHeight: "90vh",      // ✅ LIMIT HEIGHT
        overflowY: "auto",      // ✅ ENABLE SCROLL
        position: "relative",
      }}
    >
            <IconButton
                  onClick={onClose}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                               color: "#333",
        
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
          <Typography  sx={{color:"#2C384C",fontSize:"26px",fontWeight:600,  textAlign:"center",      fontFamily: 'Poppins, sans-serif',
   }}>{t("faceScanModal.title")}</Typography>
        <p style={{fontSize:"14px",color:"#8B8D97", textAlign:"center",      fontFamily: 'Poppins, sans-serif',
}} >{t("faceScanModal.subtitle")}</p>

        {!capturedImage ? (
          <Box sx={{ position: "relative", width: "100%" }}>
            {!cameraReady && !cameraError && (
              <Box
                sx={{
                  height: 250,
                  width: "100%",
                  borderRadius: "8px",
                  backgroundColor: "#F5F6F8",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                }}
              >
                <CircularProgress size={32} sx={{ color: "#006EC2" }} />
                <Typography sx={{ fontSize: "13px", color: "#8B8D97", fontFamily: "Poppins, sans-serif" }}>
                  {t("faceScanModal.loadingCamera")}
                </Typography>
              </Box>
            )}
            {cameraError && (
              <Box
                sx={{
                  height: 250,
                  width: "100%",
                  borderRadius: "8px",
                  backgroundColor: "#F5F6F8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 2,
                }}
              >
                <Typography sx={{ fontSize: "13px", color: "red", textAlign: "center", fontFamily: "Poppins, sans-serif" }}>
                  {cameraError}
                </Typography>
              </Box>
            )}
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ width: "100%", borderRadius: 8, display: cameraReady ? "block" : "none" }}
              onUserMedia={() => setCameraReady(true)}
              onUserMediaError={() =>
                setCameraError(
                  i18n.language === "es"
                    ? "No se pudo acceder a la cámara. Verifique los permisos."
                    : "Could not access the camera. Please check camera permissions."
                )
              }
            />
          </Box>
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{ width: "100%", borderRadius: 8 }}
          />
        )}

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
   
        </Box>
        {validationError && (
  <Typography
    sx={{
      color: "red",
      fontSize: "14px",
      mt: 2,
      textAlign: "center",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {validationError}
  </Typography>
)}
        <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "center",alignItems:"center" }}>

  {!capturedImage ? (
    <Button
      variant="outlined"
      onClick={capture}
      disabled={uploading || !cameraReady}
      startIcon={uploading ? <CircularProgress size={16} /> : null}
      sx={{
        fontSize: 15,
        textTransform: "none",
        borderRadius: "5px",
        fontFamily: "Poppins, sans-serif",
        color: "#006EC2",
        border: "2px solid #006EC2",
        px: 3,
        py: 1,
    height:"42px"
      }}
    >
      {uploading ? t("faceScanModal.uploading") : t("faceScanModal.capture")}
    </Button>
  ) : (
    <Button
      variant="outlined"
    onClick={() => {
  setCapturedImage(null);
  setFaceFileId(null);
  setValidationError("");
  setValidationFailed(false);
}}
      sx={{
        fontSize: 15,
        textTransform: "none",
        borderRadius: "5px",
        fontFamily: "Poppins, sans-serif",
        color: "#006EC2",
        border: "2px solid #006EC2",
        px: 3,
        py: 1,
       height:"42px"
      }}
    >
                  {t("faceScanModal.retake")}

    </Button>
  )}

  {/* Continue Button */}
  <Button
    variant="contained"
    disabled={!faceFileId}
   
 
onClick={async () => {
  if (!faceFileId) return;

  // If already failed once → allow navigation
  if (validationFailed) {
    onContinue({ face_file_id: faceFileId });
    return;
  }

  setVerifyingFace(true);

  const isValid = await validateFace(faceFileId);

  setVerifyingFace(false);

  if (!isValid) {
    setValidationFailed(true);  // 👈 next click will navigate
    return;
  }

  onContinue({ face_file_id: faceFileId });
}}
    sx={{
      fontSize: 15,
      textTransform: "none",
      borderRadius: "5px",
      fontFamily: "Poppins, sans-serif",
      backgroundColor: "#006EC2",
      color: "#fff",
      px: 4,
      py: 1,
      height:"42px",
 
      "&:hover": {
        backgroundColor: "#005bb5",
      },
    }}
  >
           {/* {t("faceScanModal.continue")} */}
           {verifyingFace
? t("faceScanModal.verifying")
: t("faceScanModal.continue")}

  </Button>
</Box>
</Box>
      </Box>
    </Modal>
  );
};

export default FaceScanModal;




